import setAsset from '../base-saving-actions/set-asset';

const updateAssets = (assetsToUpdate) =>
  assetsToUpdate.map(({ source, content = null, publishable }) => {
    const assetType = publishable ? 'publishable' : null;
    return setAsset(source, { content, assetType });
  });

export default updateAssets;
